import L from "leaflet";

export const PIN_COLOURS = {
  default: "#2f6fed",
  postcodeOnly: "#e8833a",
  muted: "#9aa3ad",
};

const PIN_WIDTH = 22;
const PIN_HEIGHT = 29;

type MapPinOptions = { label?: number | string; colour?: string };

/** The marker every Innointel map uses: a pin with a number in its head, or a white dot without one. */
export const mapPin = ({
  label,
  colour = PIN_COLOURS.default,
}: MapPinOptions = {}) => {
  const text = label === undefined ? "" : String(label);
  const head = text
    ? `<text x="15" y="15" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="${text.length > 2 ? 10 : 13}" font-weight="700" font-family="system-ui, -apple-system, sans-serif">${text}</text>`
    : `<circle cx="15" cy="14.5" r="4.5" fill="#fff" />`;
  return L.divIcon({
    className: "innointel-map-pin",
    iconSize: [PIN_WIDTH, PIN_HEIGHT],
    iconAnchor: [PIN_WIDTH / 2, PIN_HEIGHT],
    popupAnchor: [0, -PIN_HEIGHT + 3],
    tooltipAnchor: [0, -PIN_HEIGHT + 6],
    html: `<svg width="${PIN_WIDTH}" height="${PIN_HEIGHT}" viewBox="0 0 30 40" xmlns="http://www.w3.org/2000/svg" style="display:block;overflow:visible;filter:drop-shadow(0 1px 2px rgba(17,20,24,0.35))"><path d="M15 39C15 39 28 24.6 28 14.5C28 7.04 22.18 1 15 1C7.82 1 2 7.04 2 14.5C2 24.6 15 39 15 39Z" fill="${colour}" stroke="#fff" stroke-width="2"/>${head}</svg>`,
  });
};
